import { tv } from '~/utils/tv'

export const AccordionRootVariants = tv({
  base: `block w-full flex-row rounded-mediumcontainer border-quarterpulse
        hover:border-[var(--color-container-border-hovered)] mb-fourpulse
        focus:border-halfpulse focus:border-[var(--color-container-border-focused)]
        `,
  variants: {
    disabled: {
      true: `cursor-not-allowed border-[var(--color-container-border-disabled)] border-quarterpulse
              hover:border-[var(--color-container-border-disabled)]`,
      false: 'border-[var(--color-container-border-default)]',
    },
  },
})

export const AccordionVariants = tv({
  base: `flex w-full min-w-[184px] items-center justify-between bg-[var(--color-container-fill-default)] p-fourpulse font-bold font-family-modern text-fourpulse text-text-neutral gap-twopulse leading-small tracking-tiny
        hover:bg-[var(--color-container-fill-hovered)]
        outline-none
        focus-visible:border-[var(--color-container-border-focused)] focus-visible:border-halfpulse`,
  variants: {
    open: {
      true: 'rounded-t-mediumcontainer',
      false: 'rounded-mediumcontainer',
    },
    disabled: {
      true: `cursor-not-allowed border-[var(--color-container-border-disabled)] bg-[var(--color-container-fill-disabled)] text-text-neutral-disabled
              hover:border-[var(--color-container-border-disabled)] hover:bg-[var(--color-container-fill-disabled)]`,
    },
  },
})

export const AccordionIconVariants = tv({
  base: 'flex items-center justify-center transition-transform',
  variants: {
    open: {
      true: 'rotate-180',
      false: 'rotate-0',
    },
  },
})

export const AccordionContentVariants = tv({
  base: `
    whitespace-pre-wrap break-words w-full max-w-full px-fourpulse py-sixpulse
  `,
})

export const AccordionTitleVariants = tv({
  base: 'line-clamp-4',
})
